import Vue from 'vue'
import VueRouter from 'vue-router'

import Search from "@/views/Search";
import Login from "@/views/Login";
import PostWatches from "@/views/PostWatches";

import RedditAuthCb from "@/components/RedditAuthCb";
import store from '@/store'
import Compare from "@/views/Compare";
import RepostFeed from "@/views/RepostFeed";
import ImagePostFeed from "@/views/ImagePostFeed";
import TopImageReposts from "@/components/Stats/TopImageReposts";
import BannedSubreddits from "@/components/Stats/BannedSubreddits";
import TopReposters from "@/components/Stats/TopReposters";
import Home from "@/views/Home";
import EditMessageTemplates from "@/components/admin/message-templates/EditMessageTemplates";
import AdminMonitoredSubs from "@/components/admin/monitored-sub/AdminMonitoredSubs";
import MemeVoting from "@/components/meme-voting/MemeVoting";
import MySubsNew from "@/views/MySubsNew";
import Subreddit from "@/components/manage-subreddits/Subreddit";
import SubredditInfo from "@/components/manage-subreddits/SubredditInfo";
import SubredditSettings from "@/components/manage-subreddits/SubredditSettings";
import MessageTemplates from "@/components/manage-subreddits/MessageTemplates";
import PostHistory from "@/components/manage-subreddits/PostHistory";
import Activate from "@/views/Activate";
import UserWhitelist from "@/components/manage-subreddits/UserWhitelist.vue";

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: "Reddit Repost Sleuth - The Repost Detection Bot",
      description: "A high performance repost detection bot for Reddit"
    },
  },
  {
    path: '/compare',
    name: 'Compare',
    component: Compare,
    meta: {
      title: "Reddit Repost Sleuth - Compare two images",
      description: "Compare two images from Reddit posts"
    }
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: {
      title: "Reddit Repost Sleuth - Search",
      description: "Find reposts for a given Reddit post"
    }
  },
  {
    path: '/repost-feed',
    name: 'RepostFeed',
    component: RepostFeed,
    meta: {
      title: "Reddit Repost Sleuth - Repost Feed",
      description: "Live feed of all reposts found by Repost Sleuth"
    }
  },
    {
      path: '/post-feed',
      name: 'PostFeed',
      component: ImagePostFeed,
      meta: {
        title: "Reddit Repost Sleuth - Image Feed",
        description: "A raw feed of all images ingested by Repost Sleuth"
      }
    },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: "Reddit Repost Sleuth - Login",
      description: "Login Page"
    }

  },
    {
      path: '/me/watches',
      name: 'Watches',
      component: PostWatches,
      meta: {
        requiresAuth: true,
        title: "Reddit Repost Sleuth - Post Watches",
        description: "All existing post watches"
      }

    },
    {
      path: '/meme-voting',
      name: 'MemeVoting',
      component: MemeVoting,
      meta: {
        requiresAuth: true,
        title: "Reddit Repost Sleuth - Meme Voting",
        description: "Meme Voting"
      }

    },

    {
      path: '/my-subreddits/',
      name: 'MySubReddits',
      component: MySubsNew,
      meta: {
        requiresAuth: true,
        title: "Reddit Repost Sleuth - Manage Subreddit",
        description: "Managed Subreddits"
      }
    },
    {
      path: '/my-subreddits/:subredditName',
      name: 'Subreddits',
      component: Subreddit,
      props: true,
      children: [
        {
          path: 'info',
          component: SubredditInfo,
          props: true,
          meta: {
            title: "Info",
            breadCrumb: 'Info'
          }
        },
        {
          path: 'settings',
          component: SubredditSettings,
          name: 'subreddit-settings',
          props: true,
          meta: {
            title: "Settings",
            breadCrumb: 'Settings'
          }
        },
        {
          path: 'user-whitelist',
          name: 'user-whitelist',
          props: true,
          component: UserWhitelist,
          meta: {
            title: "User Whitelist",
            breadCrumb: 'User Whitelist'
          }
        },
        {
          path: 'message-templates',
          name: 'message-templates',
          props: true,
          component: MessageTemplates,
          meta: {
            title: "Message Templates",
            breadCrumb: 'Templates'
          }
        },
        {
          path: 'post-history',
          name: 'post-history',
          props: true,
          component: PostHistory,
          meta: {
            title: "Post History",
            breadCrumb: 'History'
          }
        },
        {
          path: 'activate',
          name: 'activate',
          props: true,
          component: Activate,
          meta: {
            title: "Activate",
            breadCrumb: 'Activate'
          }
        }
      ],
      meta: {
        requiresAuth: true,
        title: "Reddit Repost Sleuth - Managed Subreddit",
        description: "Manage SubReddit",
        breadCrumb: "Subreddit"
      }
    },
    {
      path: '/stats/top-image-reposts',
      name: 'TopImageReposts',
      component: TopImageReposts,
      meta: {
        title: "Reddit Repost Sleuth - Top Image Reposts",
        description: "List of the top reposted images on Reddit"
      }
    },
    {
      path: '/stats/banned-subs',
      name: 'BannedSubreddits',
      component: BannedSubreddits,
      meta: {
        title: "Reddit Repost Sleuth - Banned Subreddits",
        description: "List of subreddits that have banned Repost Sleuth"
      }
    },
    {
      path: '/stats/top-reposters',
      name: 'TopReposters',
      component: TopReposters,
      meta: {
        title: "Reddit Repost Sleuth - Top Reposters",
        description: "A list of the top reposting users on Reddit"
      }
    },

    {
      path: '/authcallback',
      name: 'AuthCallback',
      component: RedditAuthCb

    },
    {
      path: '/admin/message-templates',
      name: 'AdminMessageTemplates',
      component: EditMessageTemplates
    },
    {
      path: '/admin/monitored-subs',
      name: 'AdminMonitoredSubs',
      component: AdminMonitoredSubs
    }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next({name: 'Login', query: {origin: to.name}})
  } else {
    next()
  }
})

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    if (to.matched.some(record => record.meta.title)) {
      document.title = to.meta.title;
    }
  });
});

export default router
